import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.div`
	margin-bottom: 48px;
	position: relative;
`;

export const CarouselWrapper = styled(GridWrapper)`
	background: ${palette('white')};
	margin: 0 auto 48px;
	.slider-container {
		overflow-x: hidden;
	}
`;

export const Slide = styled.div`
	min-width: 100%;
	display: flex;
	text-align: left;
	padding: 32px;
`;

export const SlideCopy = styled.p`
	${fontWeight(FontWeights.Regular)};
`;

export const AuthorContainer = styled.div`
	align-items: center;
	display: flex;
	margin-bottom: 28px;
`;

export const AuthorImage = styled.div<{
	imageUrl: string;
}>`
	background-image: url('${(p): string => p.imageUrl}');
	background-position: center center;
	background-repeat: no-repeat;
	background-size: 100%;
	border-radius: 50%;
	height: 100px;
	margin-right: 32px;
	width: 100px;
`;

export const AuthorName = styled.h4`
	${fontWeight(FontWeights.Regular)};
`;

export const AuthorHandle = styled.p`
	color: ${palette('gray5')};
	${fontWeight(FontWeights.Regular)};
`;

export const StoryImage = styled.div`
	display: none;

	${minWidth('tablet')} {
		display: block;
		flex: 0 0 360px;
		margin-left: 48px;
		height: 360px;
		width: 360px;
	}

	${minWidth('desktop')} {
		margin-left: 60px;
	}
`;

export const Nav = styled.nav`
	align-items: center;
	display: flex;
	justify-content: center;
`;

export const Arrow = styled.div`
	height: 40px;
	width: 30px;
	cursor: pointer;

	& path {
		fill: ${palette('schoolBlue')};
		stroke: ${palette('schoolBlue')};
		stroke-linecap: round;
		stroke-width: 6;
	}

	&:last-of-type {
		transform: rotate(180deg);
	}
`;

export const NavDot = styled.div<{
	isActive: boolean;
}>`
	background: ${palette('schoolBlue')};
	border-radius: 50%;
	cursor: pointer;
	height: 8px;
	margin: 0 6px;
	opacity: ${(p): number => (p.isActive ? 1 : 0.33)};
	transition: opacity ${theme('animation.transition')};
	width: 8px;

	&:first-of-type {
		margin-left: 32px;
	}

	&:last-of-type {
		margin-right: 32px;
	}
`;
